import { findIndex } from 'lodash';

export default {
  setProperty(state, { property, payload }) {
    state[property] = payload;
  },

  setChartFilter(state, payload) {
    state.chart_filters = payload;
  },

  setChartRegion(state, payload) {
    const response = payload.charAt(0).toUpperCase() + payload.slice(1);
    const index = findIndex(state.country, { name: response });
    if (index >= 0) {
      state.region = state.country[index].iso_code;
    }
  },
};
